module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// /data/jenkins_slave/epjenkins81/workspace/IWT-GIT/00XXX-Component-Loader/node_modules/axios/index.js
// module id = 40
// module chunks = 0 1